// import React, { useState } from 'react';
// import './TourniqueteRotation.css';
// import CircularSlider from '@fseehawer/react-circular-slider';
// import { Globals } from '../../../misc/helpers';

// const lowerLimitU = 2;
// const upperLimitV = 4;//themax value should be max 4

// const colors = {
// 	blue: '#0051D8',
// 	yellow: '#DDC94C',
// 	green: '#29C852'
// };

// const TourniqueteRotation = (obj: any) => {
// 	const knobCircle = document.querySelector('circle[fill-opacity=\'0.2\']');
// 	const knobCircleHamburger = document.querySelector('svg[viewBox=\'0 0 36 36\']');

// 	const [totalRotationsX, setTotalRotationsX] = useState(randomNumber(lowerLimitU, upperLimitV));
// 	const [rotatedTimes, setRotatedTimes] = useState(0);

// 	const yellowColorPercentage = totalRotationsX / 2;
// 	const greenCollorPercentage = totalRotationsX;

// 	const [rotationWay, setRotationWay] = useState({ //use to determine is full circle passed
// 		next: 0,
// 		prev: 0
// 	});

// 	function randomNumber(min: number, max: number) {
// 		const r = Math.random() * (max - min + 1) + min;
// 		return Math.floor(r);
// 	}

// 	if (knobCircle) {
// 		knobCircle.setAttribute('stroke', '#008abc');
// 		knobCircle.setAttribute('fill-opacity', '1');
// 	}

// 	if (knobCircleHamburger) {
// 		knobCircleHamburger.remove();
// 	}

// 	return (
// 		<div className={`modal-disable-select ui-container ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
// 			<div className="ui-inner-container tourniquete-rotation-container">
// 				<div className="slider-border">
// 				</div>
// 				<CircularSlider
// 					label=""
// 					direction={1}
// 					labelFontSize={0}
// 					labelColor="transparent"
// 					knobColor="#ffaf0a"
// 					knobSize={50}
// 					trackColor="#0051d8"
// 					trackSize={30}
// 					dataIndex={0}
// 					width={400}
// 					progressSize={16}
// 					onChange={(value: number) => {
// 						var percentage = rotatedTimes + ((value) / 360);

// 						console.log(percentage);
// 						console.log(rotationWay);

// 						if (rotationWay.next < 90 && rotationWay.prev > 270)
// 							setRotatedTimes(prev => prev + 1);

// 						if (rotationWay.prev < 90 && rotationWay.next > 270) {
// 							setRotatedTimes(0);
// 							percentage = 0;
// 						}

// 						setRotationWay(prevWay => ({
// 							...prevWay,
// 							next: value,
// 							prev: prevWay.next,
// 						}));

// 						if (obj.parameters.onUpdate) {
// 							obj.parameters.onUpdate(Math.abs(percentage));
// 						}
// 						obj.parameters.dispatch({
// 							type: 'playSequence',
// 							value: {
// 								sequenceName: 'RotateTourniquete',
// 								props: {
// 									sequenceProps: {
// 										percentage: Math.abs(percentage)
// 									}
// 								},
// 								skipAnimations: Globals.skipAnimations
// 							}
// 						});


// 						let color =
// 							(Math.abs(percentage) >= greenCollorPercentage)
// 								? colors.green
// 								: (Math.abs(percentage) >= yellowColorPercentage)
// 									? colors.yellow
// 									: colors.blue;
// 						let circle = document.querySelector('circle');
// 						if (circle)
// 							circle.setAttribute('stroke', color);
// 					}}
// 				/>
// 			</div>
// 		</div >
// 	);
// };

// export default TourniqueteRotation;

import React, { useState, useEffect, useCallback } from 'react';
import $ from 'jquery';
import './TourniqueteRotation.css';
import { Globals } from '../../../misc/helpers';

const TourniqueteRotation = (obj: any) => {
	const lowerLimitU = 3;
	const upperLimitV = 4;//themax value should be max 4

	const colors = {
		blue: '#0051D8',
		yellow: '#DDC94C',
		green: '#29C852'
	};

	const [isMoving, setIsMoving] = useState(false);
	const [color, setColor] = useState(colors.blue);

	const [totalRotationsX] = useState(randomNumber(lowerLimitU, upperLimitV));

	const [rotatedTimes, setRotatedTimes] = useState(0);

	const yellowColorPercentage = totalRotationsX / 2;
	const greenColorPercentage = totalRotationsX;

	function randomNumber(min: number, max: number) {
		const r = Math.random() * (max - min + 1) + min;
		return Math.floor(r);
	}

	const radius = 185;
	
	const [sliderWH, setSliderWH] = useState({ w: 0, h: 0 });
	const [elPos, setElPos] = useState({ x: 0, y: 0 });
	const [sliderOffset, setSliderOffset] = useState({ x: 0, y: 0 });

	const [previousDeg, setPreviousDeg] = useState(0);
	const [halfCircleDone, setHalfCircleDone] = useState(false);

	const functionalRotate = (deg : any) => {
		var X = Math.round(radius * Math.sin(deg * Math.PI / 180));
		var Y = Math.round(radius * -Math.cos(deg * Math.PI / 180));

		$('#slider, #slider-arrow').css({ left: X + radius - sliderWH.w, top: Y + radius - sliderWH.h });
		//apply exact degrees to ball rotation
		$('#slider-arrow').css({ WebkitTransform: 'rotate(' + deg + 'deg)' });
		$('#slider-arrow').css({ '-moz-transform': 'rotate(' + deg + 'deg)' });

		var percentage = rotatedTimes + (deg / 360);
		let newColor =
			(Math.abs(percentage) >= greenColorPercentage)
				? colors.green
				: (Math.abs(percentage) >= yellowColorPercentage)
					? colors.yellow
					: colors.blue;

		setColor(newColor);

		if (Math.abs(percentage) >= greenColorPercentage) {
			setIsMoving(false);
		}

		if (obj.parameters.onUpdate) {
			obj.parameters.onUpdate(Math.abs(percentage), greenColorPercentage);
		}
		obj.parameters.dispatch({
			type: 'playSequence',
			value: {
				sequenceName: 'RotateTourniquete',
				props: {
					sequenceProps: {
						percentage: Math.abs(percentage)
					}
				},
				skipAnimations: Globals.skipAnimations
			}
		});
	};

	const rotate = useCallback((e) => {
		if (isMoving) {
			const evt = e.type === 'touchmove' ? e.changedTouches[0] : e;

			var scaleNumber = getScaleValue();
			var mPos = { x: (evt.clientX / scaleNumber) - elPos.x - sliderOffset.x, y: (evt.clientY / scaleNumber) - elPos.y - sliderOffset.y };

			var atan = Math.atan2(mPos.x - radius, mPos.y - radius);
			var deg = -atan / (Math.PI / 180) + 180; // final (0-360 positive) degrees from mouse position 

			if (deg > 90 && deg < 270)
				setHalfCircleDone(true);

			if (((deg == 0 && previousDeg != 0) || (previousDeg > 350 && deg < 10)) && halfCircleDone) {
				setHalfCircleDone(false);
				setRotatedTimes(prev => prev + 1);
			}

			if (previousDeg == 0 && deg > 330) return;

			setPreviousDeg(deg);

			if (deg < previousDeg && (previousDeg < 359 && deg > 0)) return;

			functionalRotate(deg);
		}
	}, [isMoving, sliderOffset, rotatedTimes, previousDeg, halfCircleDone]);

	var onChangeValueKeyboard = useCallback((evt: any) => {
		if(evt.keyCode == 39){
			setSliderOffset({ x: 0, y: 0});
			let newDeg = previousDeg + 10;
			setPreviousDeg(newDeg);
			functionalRotate(newDeg);
		}
	}, [isMoving, sliderWH, sliderOffset, rotatedTimes, previousDeg, halfCircleDone]);

	const getScaleValue = () => {
		var matrix = $('.ui-container-root').css('transform');
		var scale = matrix.split('(')[1];
		scale = scale.split(')')[0];
		return +scale.split(',')[0];
	};

	useEffect(() => {
		function handleResize() {
			var $slider = $('#slider');

			var scaleNumber = getScaleValue();
			setSliderWH({ w: $slider.width() / 2, h: $slider.height() / 2 });

			var elP = $('#circle').offset();
			var x = elP.left / scaleNumber;
			var y = elP.top / scaleNumber;

			console.log('Start X ' + x + ' Start y' + y);
			setElPos({ x: x, y: y });
		}

		window.addEventListener('resize', handleResize);

		handleResize();
	}, []);
	return (
		<div className={`modal-disable-select ui-container ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
			<div className="ui-inner-container tourniquete-rotation-container">
				<div id='circle-border'>
					<div id='circle-arc' style={{ borderColor: color }}>
					</div>
				</div>
				<div id='circle'
					onMouseDown={(e) => {
						setSliderOffset({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
					}}
					onTouchStart={(e) => {
						let eventTarget = e.target as HTMLElement;
						let bcr = eventTarget.getBoundingClientRect();
						let x = e.targetTouches[0].clientX - bcr.x;
						let y = e.targetTouches[0].clientY - bcr.y;
						setSliderOffset({ x: x, y: y });
					}}
					onMouseUp={() => setIsMoving(false)}
					//onMouseOut={() => setIsMoving(false)}
					>
					<div id="slider-arrow" style={{
						background: 'url(assets/img/tourniquet-rotate-arrow.svg)'
					}}></div>
					<div id='slider'
						tabIndex={0}
						aria-label="Drag to tighten tourniquet" 
						role="slider"
						onKeyDown={onChangeValueKeyboard}
						onTouchStart={() => setIsMoving(true)}
						onTouchEnd={() => setIsMoving(false)}
						onTouchCancel={() => setIsMoving(false)}
						onMouseDown={() => setIsMoving(true)}
						onMouseUp={() => setIsMoving(false)}
						// onMouseOut={() => setIsMoving(false)}
						onMouseMove={(e) => { rotate(e.nativeEvent); }}
						onTouchMove={(e) => { rotate(e.nativeEvent); }}
					>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TourniqueteRotation;
